export default __webpack_public_path__ + "static/media/banner-def.34c5a95f.png";